import { merge } from 'lodash-es';

import { extensionLocale } from '@lib/extensions';

import en from './en';
import de from './de';

// The texts of the extensions come with their manifests and are always merged in: an extension
// that is off has no screen that would ask for them, and its components stay importable.
const extensions = extensionLocale();

export default {
	en: merge({}, en, extensions.en),
	de: merge({}, de, extensions.de),
};
